export const mailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;